import { useState } from 'react'

import { useAuth0 } from 'shim/auth0-react'

import { CREATE_USER_API_TOKEN } from '../queries'
import { CREATE_ACCOUNT_API_TOKEN } from '../queries'
import { consoleFetcher } from 'common/fetchers/graphql'

interface ApiKeyCreationData {
  loading: boolean
  err: null | Error
  data: string | null
}

export default function useCreateApiKey(account?: string) {
  const { getAccessTokenSilently } = useAuth0()

  const [requestState, setRequestState] = useState<ApiKeyCreationData>({
    loading: false,
    err: null,
    data: null,
  })
  const createApiKey = async (note: string) => {
    setRequestState({
      data: null,
      loading: true,
      err: null,
    })

    try {
      let query = CREATE_USER_API_TOKEN
      if (account) {
        query = CREATE_ACCOUNT_API_TOKEN
      }
      const response = await consoleFetcher(
        query,
        {
          note: note,
          accountID: account,
          accessLevel: 'admin', // only for account api keys. TODO: allow setting this
        },
        { tokenFn: getAccessTokenSilently }
      )

      if (!(response.createUserAPIToken || response.createAccountAPIToken)) {
        throw new Error('The API returned an invalid response.')
      }
      setRequestState({
        loading: false,
        err: null,
        data: response.createUserAPIToken ? response.createUserAPIToken : response.createAccountAPIToken,
      })
    } catch (error) {
      setRequestState({
        loading: false,
        err: error as Error,
        data: null,
      })
    }
  }

  return { createApiKey, err: requestState.err, loading: requestState.loading, data: requestState.data }
}
